/**
 * Shared `className` for LLM chat assistant markdown: typography + bordered GFM tables.
 */
export const llmChatMarkdownProseClassName = [
  'prose prose-sm min-w-0 max-w-none dark:prose-invert',
  'prose-table:text-xs md:prose-table:text-sm',
  '[&_table]:w-full [&_table]:border-collapse [&_table]:border [&_table]:border-border',
  '[&_th]:border [&_th]:border-border [&_th]:bg-muted/50 [&_th]:px-2 [&_th]:py-1.5 [&_th]:text-left [&_th]:align-top',
  '[&_td]:border [&_td]:border-border [&_td]:px-2 [&_td]:py-1.5 [&_td]:align-top',
].join(' ')
